

















import { defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api';
import Modal from '@/renderer/components/mobile/base/Modal/index.vue';
import ipc from '@/renderer/scripts/utils/ipc';
import guideHandle from '@/renderer/views/desktop/FileManagement/Workbench/composition/guideHandler';
import mWelcome from '@/renderer/assets/images/dialog/mWelcome.svg';
export default defineComponent({
  name: 'MobieWeclome',
  components: {
    Modal,
  },
  setup() {
    const innerShow = ref(false);
    const {
      methods: { customeCreateNoviceGuidance },
    } = guideHandle();
    const methods = {
      open() {
        innerShow.value = true;
        reporter.report('manager_new_guide', {
          welcome_pop_up: 'show',
        });
      },
      openStart() {
        innerShow.value = false;
        ipc.emit(ipc.RENDERER_EVENTS_MAP.START_MOBILE_USER_SURVEY);
        // 用于插入新的数据、判断不再是新入首次进入的用户
        customeCreateNoviceGuidance();
      },
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.START_MOBILE_GUIDE, methods.open);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.START_MOBILE_GUIDE, methods.open);
    });
    return {
      mWelcome,
      innerShow,
      ...methods,
    };
  },
});
